// Shared presentation of the archive's Indexability model
// ({ indexable, notIndexableReasons }) — used by the snapshot field and the change diff.

export const reasonMap = {
    "BLOCKED_BY_ROBOTS_TXT": "Blocked by Robots.txt",
    "META_NOINDEX":           "Meta Noindex",
    "CANONICALIZED":          "Canonicalized",
    "X_ROBOTS_NOINDEX":       "X-Robots Noindex",
};

export function indexabilityText(indexability) {
    if (indexability?.indexable == null) return null;   // no verdict — unknown / not tracked yet
    if (indexability.indexable) return 'Indexable';
    const reasons = (indexability.notIndexableReasons || []).map(r => reasonMap[r] || r);
    return `Non-Indexable: ${reasons.join(', ')}`;
}
